import React from "react";
import "../../src/styles/Contact.css";
import { FiMapPin, FiMail, FiPhone } from "react-icons/fi";
import con from "../assets/images/contact.jpg";
import Features from "../pages/Features";
import { Link } from "react-router-dom";

function Contact() {
  return (
    <div>
      <div className="contact-section">
        <img src={con} alt="banner" />
        <div className="banner-contentt">
          <h1>Contact Us</h1>
          <p>
            <span>
              <Link to="/" className="breadcrumb-link">
                Home
              </Link>
            </span>
            / Contact
          </p>
        </div>
      </div>
      <div className="contact-wrapper">
        <div className="contact-container">
          <div className="contact-info">
            <span className="small-title">Get in Touch</span>
            <h2>We will connect with you shortly</h2>
            <p className="desc">
              At Sankalp Ayurveda, your health and satisfaction matter to us.
              Feel free to reach out for product queries, order support, or
              general assistance. Our team is always happy to help.
            </p>

            <div className="info-item">
              <div className="icon">
                <FiMapPin />
              </div>
              <div>
                <h4>Location</h4>
                <p>
                 Logix Technova Sector-132, Greater Noida, <br />Uttar Pradesh, India - 201304
                </p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon">
                <FiMail />
              </div>
              <div>
                <h4>Email Us</h4>
                <p>
                 Sankalphealth10@gmail.com


                </p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon">
                <FiPhone />
              </div>
              <div>
                <h4>Call Us</h4>
                <p>
                 +91 9211710043
                  <br />
                  Business Hours :- Mon – Sat (10 AM – 6 PM)
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT SECTION */}
          <div className="contact-form">
            <span className="small-title">Send us a message</span>
            <h2>Have any questions?</h2>
            <p className="desc">
              Share your details below and our Sankalp Ayurveda support team will
              get back to you as soon as possible.
            </p>

            <form>
              <div className="row">
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Phone Number" />
              </div>

              <input type="email" placeholder="Email Address" />
              <input type="text" placeholder="Subject" />
              <textarea placeholder="Your Message"></textarea>

              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </div>
      <Features />
    </div>
  );
}

export default Contact;
